import gazetteer, { CountryCodes } from '@bridebook/toolbox/src/gazetteer';

/**
 * Set of utils to normalize locations ( cities and countries ) and handling special cases.
 */
export const GEO_NAMES = {
  UK: gazetteer.getMarketByCountry(CountryCodes.GB).getCountryName(),
};
